import { render, staticRenderFns } from "./mealdecl.vue?vue&type=template&id=6f204958&scoped=true&"
import script from "./mealdecl.vue?vue&type=script&lang=js&"
export * from "./mealdecl.vue?vue&type=script&lang=js&"
import style0 from "./mealdecl.vue?vue&type=style&index=0&id=6f204958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f204958",
  null
  
)

export default component.exports